import './OkCancelDialog.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, MessageBar, MessageBarType, IDialogContentProps } from '@fluentui/react';
import { isValidElement } from 'react';
import { InternalDialogContent } from './InternalDialogContent';

export interface OkCancelDialogProps {
  title: string;
  subText?: string | JSX.Element;
  warning?: string;
  onOk?: () => void;
  okText?: string;
  hasCancel?: boolean,
  onCancel?: () => void;
}

export class OkCancelDialog {
  public static show(options: OkCancelDialogProps) {
    const dialogNode = document.createElement('div');
    const close = (): void => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<OkCancelDialogInternal {...options} close={close} />, dialogNode);
  }
}

class OkCancelDialogInternal extends React.Component<OkCancelDialogProps & { close: () => void }> {
  public render(): JSX.Element {
    const { title, subText, okText } = this.props;

    const hasStyledSubText = isValidElement(subText);

    const dialogContentProps: IDialogContentProps = {
      type: DialogType.normal,
      title: hasStyledSubText ? InternalDialogContent(title, subText as JSX.Element) : title,
      subText: hasStyledSubText || !subText ? undefined : (subText as string),
    };

    return (
      <Dialog
        hidden={false}
        dialogContentProps={dialogContentProps}
        onDismiss={this.cancel}
        modalProps={{
          isBlocking: true,
          className: 'ok-cancel-dialog',
        }}
      >
        {this.props.warning && (
          <MessageBar messageBarType={MessageBarType.severeWarning} styles={{ root: { marginBottom: 25 } }}>
            {this.props.warning}
          </MessageBar>
        )}
        <DialogFooter>
          <PrimaryButton onClick={this.ok}>{okText ?? 'OK'}</PrimaryButton>
          { this.props.hasCancel !== false && <DefaultButton onClick={this.cancel}>Cancel</DefaultButton> }
        </DialogFooter>
      </Dialog>
    );
  }

  private ok = () => {
    if (this.props.onOk) {
      this.props.onOk();
    }
    this.props.close();
  };

  private cancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.props.close();
  };
}
